import {Component, OnInit} from '@angular/core';
import {HeaderComponent} from "../header/header.component";
import {FooterComponent} from "../footer/footer.component";
import {CandidateProfileService} from "../service/candidate-profile.service";
import {CandidateProfile} from "../dto/candidate-profile";
import {DatePipe, JsonPipe, KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {SalaryExpectationField} from "../dto/salary-expectation-field";
import {LuxoftExperience} from "../dto/luxoft-experience";
import {PreviousInterview} from "../dto/previous-interview";
import {FeedbackMessage} from "../dto/feedback-message";
import {SanitizeHtmlPipe} from "../utils/sanitize-html-pipe";
import {MatTooltip} from "@angular/material/tooltip";
import {saveAs} from 'file-saver';
import {ToastrService} from "ngx-toastr";
import {AbsentBlockComponent} from "./absent-block/absent-block.component";

@Component({
  selector: 'app-candidate-profile',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgForOf,
    KeyValuePipe,
    NgIf,
    DatePipe,
    JsonPipe,
    SanitizeHtmlPipe,
    MatTooltip,
    AbsentBlockComponent
  ],
  templateUrl: './candidate-profile.component.html',
  styleUrl: './candidate-profile.component.css'
})
export class CandidateProfileComponent implements OnInit {
  candidateProfile: CandidateProfile;
  hideBlocks: string[] = []

    constructor(private candidateProfileService: CandidateProfileService,
                private alert: ToastrService) {
  }

  ngOnInit(): void {
    this.candidateProfile = this.candidateProfileService.candidateProfile;
    this.candidateProfile.field_groups.forEach(fieldGroup=> {
      fieldGroup.fields = Object.entries(fieldGroup.fields).map(([key, value]) => ({key, value}));
    })
  }

  extractUuids(inputString: string): any[] {
    // Regular expression to match UUIDs
    const uuidRegex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;

    // Extract matches using the regex
    const uuidList = inputString.match(uuidRegex);

    // Return an array of UUIDs, or an empty array if no matches found
    return uuidList ? uuidList.map(uid => this.findSkillById(uid)) : [];
  }

  findSkillById(skillId: string): any | null {
    // Use Array.find() to search for the skill with the given skillId

    const skill = this.candidateProfile.selfEvaluatedSkills.find(skill => skill.skillId === skillId);

    // Return the found skill or null if not found
    return skill ? skill : "";
  }


  getSortedExperience() {
    const experienceMap = new Map<Date, LuxoftExperience>(
      Object.entries(this.candidateProfile.luxoft_experiences).map(([key, value]) => [new Date(key), value]));

    return Array.from(experienceMap.entries()).sort((a, b) => {
      const dateA = new Date(a[0]);
      const dateB = new Date(b[0]);
      return dateB.getTime() - dateA.getTime();
    });
  }

  hideBlock(title: string) {
    if (this.hideBlocks.includes(title)) {
      this.hideBlocks.splice(this.hideBlocks.indexOf(title), 1);
      return;
    }
    this.hideBlocks.push(title);
  }

  getSalaryExpectation(expectation: SalaryExpectationField) {
    return `${expectation.grossNett} ${expectation.period}, for ${expectation.location},
    ${expectation.specialization}, ${expectation.seniorityLevel}`;
  }

  getExperienceDetails(experience: LuxoftExperience) {
    const fields: { [key: string]: string | undefined } = {
      "Hiring Manager": experience.hiringManager,
      "Business Unit": experience.businessUnit,
      "Location": experience.location,
      "Vacancy": experience.vacancy
    };

    return Object.entries(fields)
      .filter(([, value]) => value)
      .map(([key, value]) => `${key}: ${value}`)
      .join('; ');
  }

  showDetails(technicalInterview: PreviousInterview) {
    technicalInterview.showDetails = !technicalInterview.showDetails;
  }

  feedbackShowDetails(feedback: FeedbackMessage) {
    feedback.showDetails = !feedback.showDetails;
  }

  downloadFile(attachmentKey: string, attachmentHash: string, fileName: string) {
    this.candidateProfileService.downloadFile(attachmentKey, attachmentHash)
      .subscribe({
        next: (data) => {
          saveAs(data, fileName);
        },
        error: (error) => {
          this.alert.error('Error downloading file ' + fileName);
        }
      })
  }

  isTextOverflow(elementId: string): boolean {
    const elem = document.getElementById(elementId);
    if (elem) {
      return (elem.offsetWidth < elem.scrollWidth);
    }
    return false;
  }

  formatText(input: string): string {
    return input.replace(/([,;])(?=\S)/g, '$1 ');
  }

  protected readonly Number = Number;
}
